import { dataHooks as wixDataHooks } from '@wix/data-hooks'

export const dataHooks = wixDataHooks<{
  title: {}
  item: { index: number }
  image: { index: number }
}>('wix-intros-box-xl')
